import React from 'react';
import { useMediaQuery } from 'react-responsive';
import SunbaeBriefingPc from './designcomponents/sunbaebriefingpc';
import SunbaeBriefingMobile from './designcomponents/sunbaebriefingmobile';

export default function SunbaeBriefing() {
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  return isMobile ? <SunbaeBriefingMobile /> : <SunbaeBriefingPc />;
}
